<template>
  <div id="func-53-listagem">
    <funcionalidade-header :titulo="'Histórico de Consultas'"></funcionalidade-header>
    <div class="listagem-historico">
    <listagemStatus
      :style="'--cor-primaria:' + estilo.aplicacao.corPrimariaAplicacao + '0A'"
      :listagem-data="data"
      :columns="columns"
      :click-row="detalhe"
      :status-field="'status'">
    </listagemStatus>
    </div>
  </div>
</template>
<script>
import FuncionalidadeHeader from '@/components/FuncionalidadeHeader/FuncionalidadeHeader'
import ListagemStatus from '@/components/listagemColumn/ListagemStatus'
import { mapGetters, mapState } from 'vuex'
import DateDayNameItem from '@/components/listagemColumn/DateDayNameItem'
import HoraPeriodo from '@/components/listagemColumn/HoraPeriodo'
import MultiFieldItem from '@/components/listagemColumn/MultiFieldItem'
import LocalItem from '@/components/listagemColumn/LocalItem'
import AcoesItem from '@/components/listagemColumn/AcoesItem'
import { EnumCanalAtendimentoOrigem } from '@/constants/EnumCanalAtendimentoOrigem'
import ArrowButton from '@/components/listagemColumn/ArrowButton.vue'
import AcoesMinhasConsultas from '@/components/listagemColumn/AcoesMinhasConsultas.vue'
import CountDown from '@/components/listagemColumn/CountDown'
import ColunaIcone from '@/components/listagemColumn/ColunaIcone'
export default {
  data () {
    return {
      data: []
    }
  },
  components: { FuncionalidadeHeader, ListagemStatus },
  computed: {
    ...mapState('SetupApp', ['apiFuncionalidade', 'funcionalidade']),
    ...mapGetters('Login', ['user']),
    ...mapGetters('SetupApp', ['estilo', 'canalAtendimentoOrigem']),
    defineColunaAcao () {
      switch (this.canalAtendimentoOrigem) {
        case EnumCanalAtendimentoOrigem.MOSIA_DESK:
          return { component: AcoesItem, width: 'auto' }
        default:
          return { component: ArrowButton, width: '20px' }
      }
    },
    columns () {
      return [
        { field: 'dataHora', component: DateDayNameItem, width: '96px' },
        { field: 'dataHora', component: HoraPeriodo, width: '80px' },
        { field: ['especialidade', 'profissional', 'paciente', 'servico'], component: MultiFieldItem, width: 'auto', click: this.detalhe },
        { field: ['tipoAgenda', 'localAtendimento'], component: LocalItem, width: 'auto' },
        [
          { component: CountDown, field: ['dataHora', 'status'], width: 'auto' },
          { component: AcoesMinhasConsultas, width: 'auto' }
        ],
        { field: 'consultaConfirmada', component: ColunaIcone, width: '20px', noPadding: true },
        this.defineColunaAcao
      ]
    }
  },
  methods: {
    detalhe (row) {
      this.$router.push({ path: '/53/detalhe', query: { consulta: row } })
    },
    ordenarDataHora (data, order = 'asc') {
      return data.sort((a, b) => {
        if (order === 'asc') {
          return new Date(a.dataHora) - new Date(b.dataHora)
        } else {
          return new Date(b.dataHora) - new Date(a.dataHora)
        }
      })
    }
  },
  async created () {
    const range = this.funcionalidade.parametros.rangeDataListaConsultas
    const hoje = new Date()
    const dataInicial = new Date(hoje)
    dataInicial.setMonth(dataInicial.getMonth() - range)
    const dataFinal = new Date(hoje)
    dataFinal.setMonth(dataFinal.getMonth() + range)
    const formatarData = data =>
      data.toISOString().split('T')[0]

    let result = await this.apiFuncionalidade.listaConsultas({
      payload: {
        dataInicial: formatarData(dataInicial),
        dataFinal: formatarData(dataFinal)
      },
      loading: true,
      headers: {
        order: 'desc'
      } })

    this.data = this.ordenarDataHora(result.data.agendas, 'desc')
  }
}
</script>
<style lang="less">
#func-53-listagem {
  .el-table .el-table__body .el-table__row td {
    background-color: var(--cor-primaria)
  }
  .listagem-historico {
    padding: 20px;
  }
}
</style>
